var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.visible,"before-close":_vm.handleClose}},[_c('MarkdownDisplay',{attrs:{"value":_vm.answer.description}}),(_vm.answer.attachment)?_c('FileDownloadCard',{attrs:{"href":_vm.answer.attachment}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }